import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { LinkTo } from '../../../PageLayout/Link/Link';
import Markdown from 'markdown-to-jsx';
import ProjectUserPref from '../../Project/component/ProjectUserPref';
import ProjectService from '../../../Services/ProjectService';
import projectImagePlaceholder from "images/projectImagePlaceholder.svg";


class ProjectCarouselItem extends Component {
  static propTypes = {
    project: PropTypes.any,
  }

  constructor(props) {
    super(props);

    this.state = {
      projectImage: projectImagePlaceholder,
    };
  }

  componentDidMount() {
    if (this.props.project && this.props.project.projectId) {
      ProjectService.getProjectImage(this.props.project.projectId)
        .then(imageUrl => {
          this.setState({ projectImage: imageUrl });
        })
        .catch((error) => clearTimeout(error.errorDisplayTimer));
    }
  }


  render() {
    const ovrridedH1 = ({ children }) => (
      <h4>{children}</h4>
    );
    const ovrridedH2 = ({ children }) => (
      <h5>{children}</h5>
    );const ovrridedH3 = ({ children }) => (
      <h6>{children}</h6>
    );
    const { project } = this.props
    if (!project) {
      return (
        <div></div>
      );
    }

    return (
      <div {...LinkTo(`/project/${this.props.project.projectId}`)}>
        <Row>
          <Col sm={6} >
            <img className="projectImage" alt={project.shortName} src={this.state.projectImage} />
          </Col>
          <Col sm={6} >
            <Row>
              <Col className="projectName" md={8}>
                <h3>{this.props.project.name}</h3>
                <div> {project.devOpsDescription && project.devOpsDescription.length > 0
                  ? <Markdown projectId={project.projectId} maxSize={100} options={{
                    overrides: {
                      h1: {
                        component: ovrridedH1
                      },
                      h2: {
                        component: ovrridedH2
                      },
                      h3: {
                        component: ovrridedH3
                      },
                    },
                  }}>
                    {this.props.project.devOpsDescription}</Markdown>
                  : <p>{project.description}</p>
                }</div>
              </Col>
              <Col className='star'>
                <ProjectUserPref projectId={project.projectId} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ProjectCarouselItem;
